<template>
  <w-icon-wrapper
    :height='20'
    :width='20'
    icon-name='work-radio-selected-icon'
    view-box='0 0 20 20'
  >
    <g
      id='Radio_Button_Selected'
      data-name='Radio Button Selected'
      transform='translate(-1127 -831)'
    >
      <circle
        id='Ellipse_1549'
        cx='10'
        cy='10'
        data-name='Ellipse 1549'
        fill='currentColor'
        r='10'
        transform='translate(1127 831)'
      />
      <circle
        id='Ellipse_1550'
        cx='6'
        cy='6'
        data-name='Ellipse 1550'
        fill='#fff'
        r='6'
        transform='translate(1131 835)'
      />
    </g>
  </w-icon-wrapper>
</template>

<script>
export default { name: 'WorkIconRadioSelected' };
</script>
